import {makeAutoObservable, toJS} from "mobx";
import {ensureVar} from "./lib/utils";

const domain: string | undefined = process.env.DOMAIN;
const appEnv: string = ensureVar(process.env, "APP_ENV");

interface scConfigInterface {
    simulateUploads: boolean
    appName: string,
    appEnv: string | undefined,
    appUrl: string | undefined,
    apiUrl: string | undefined,
    wsUrl: string | undefined,
    authDisabled: boolean,
    appVersion: string | undefined,
    lastCommitMessage: string | undefined,
    apiToken: string | undefined
}

const scConfig: scConfigInterface = {
    appName: "Shadow Chat",
    appEnv: process.env.APP_ENV,
    appUrl: appEnv === "dev" ? process.env.APP_URL : `https://${domain}`,
    apiUrl: appEnv === "dev" ? process.env.API_URL : `https://${domain}/api`,
    wsUrl: appEnv === "dev" ? process.env.WS_URL : `wss://${domain}/ws`,
    authDisabled: process.env.AUTH_DISABLED === 'true',
    appVersion: process.env.APP_VERSION,
    lastCommitMessage: process.env.LAST_COMMIT_MESSAGE,
    apiToken: undefined,
    simulateUploads: process.env.APP_ENV === "dev" && process.env.SIMULATE_UPLOADS === "true"
};

makeAutoObservable(scConfig);

interface Window {
    appConfig: {
        config?: unknown,
        _config: scConfigInterface
    }
}

declare let window: Window;

if (typeof window !== "undefined") {
    window.appConfig = {
        ...window.appConfig,
        get config() {
            return toJS(scConfig)
        },
        _config: scConfig,
    }
}

export default scConfig;
